import React from 'react';

interface AccordionCardProps {
    title: string;
    id: string;
    defaultOpen?: boolean;
    children: React.ReactNode;
}

const AccordionCard: React.FC<AccordionCardProps> = ({ title, id, defaultOpen = true, children }) => {
    const accordionId = `accordion-${id}`;
    const collapseId = `collapse-${id}`;

    return (
        <div className="card mb-3">
            <div className="accordion accordion-flush" id={accordionId}>
                <div className="accordion-item">
                    <button className={`accordion-header ${!defaultOpen ? 'collapsed' : ''}`} type="button" data-bs-toggle="collapse" data-bs-target={`#${collapseId}`} aria-expanded={defaultOpen}>
                        <div className="accordion-header-text">
                            <h4>{title}</h4>
                        </div>
                        <div className="accordion-header-toggle">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-1">
                                <path d="M6 9l6 6l6 -6"></path>
                            </svg>
                        </div>
                    </button>
                    <div id={collapseId} className={`accordion-collapse collapse ${defaultOpen ? 'show' : ''}`} data-bs-parent={`#${accordionId}`}>
                        <div className="accordion-body">{children}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccordionCard;
